module.exports = __webpack_public_path__ + "img/normal_icon_01.3d6cf4f.png";